import Vue from "vue";
import VueRouter from "vue-router";

const ADMIN_INIT_PAGE = "petManage";
const EMPLOYEE_INIT_PAGE = "petManage";
const SUPER_ADMIN_INIT_PAGE = "clinicManage";
import my from "../plugins/my";
Vue.use(my);
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: () => {
      console.log(
        "Vue.prototype.$my.getPermission():" + Vue.prototype.$my.getPermission()
      );
      console.log("Vue.prototype.$my.isLogin():" + Vue.prototype.$my.isLogin());
      if (!Vue.prototype.$my.isLogin()) {
        return "/login";
      } else if (Vue.prototype.$my.getPermission() === "role_admin") {
        return { name: ADMIN_INIT_PAGE };
      } else if (Vue.prototype.$my.getPermission() === "role_staff") {
        return { name: EMPLOYEE_INIT_PAGE };
      } else if (
        Vue.prototype.$my.getPermission() === "role_superadmin" &&
        Vue.prototype.$my.getClinic()
      ) {
        return { name: ADMIN_INIT_PAGE };
      } else {
        return { name: SUPER_ADMIN_INIT_PAGE };
      }
    }
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // },
  // {
  //   path: "/foo",
  //   name: "foo",
  //   component: () => import(/* webpackChunkName: "about" */ "../views/Foo.vue")
  // },
  {
    path: "/pdfWhitePage",
    name: "pdfWhitePage",
    meta: {
      renderAt: "alone"
    },
    components: {
      alone: () => import("../views/common/PdfWhitePage.vue")
    }
  },
  {
    path: "/login",
    name: "login",
    meta: {
      renderAt: "alone"
    },
    components: {
      alone: () => import("../views/Login.vue")
    }
  },
  {
    path: "/petManage",
    name: "petManage",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    components: {
      default: () => import("../views/clinic/PetManage.vue")
    }
  },
  {
    path: "/petManage/petProfile/:petId/:reportId",
    name: "petProfileFromPetManage",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    props: { default: true },
    components: {
      default: () => import("../views/clinic/PetProfile.vue")
    }
  },
  {
    path: "/petManage/petProfile/:petId/:reportId/healthReport/ladyicats/:date",
    name: "updateHealthReportFromPetManage",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    props: { default: true },
    components: {
      default: () => import("../views/clinic/HealthReport/ReportLadyicats.vue")
    }
  },
  {
    path: "/accountManage",
    name: "accountManage",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    components: {
      default: () => import("../views/clinic/AccountManage.vue")
    }
  },
  {
    path: "/accountManage/profile/:phone",
    name: "accountProfile",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    props: { default: true },
    components: {
      default: () => import("../views/clinic/AccountProfile.vue")
    }
  },
  {
    path: "/accountManage/profile/:phone/petProfile/:petId/:reportId",
    name: "petProfileFromAccountProfile",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    props: { default: true },
    components: {
      default: () => import("../views/clinic/PetProfile.vue")
    }
  },
  {
    path:
      "/accountManage/profile/:phone/petProfile/:petId/:reportId/healthReport/ladyicats/:date",
    name: "updateHealthReportFromAccountProfile",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    props: { default: true },
    components: {
      default: () => import(`../views/clinic/HealthReport/ReportLadyicats.vue`)
    }
  },
  {
    path: "/clinicManage",
    name: "clinicManage",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin"]
    },
    components: {
      default: () => import("../views/system/ClinicManage.vue")
    }
  },
  {
    path: "/userProfile",
    name: "userProfile",
    meta: {
      requiresAuth: true,
      renderAt: "blank",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    components: {
      blank: () => import("../views/common/UserProfile.vue")
    }
  },
  {
    path: "/guideline",
    name: "guideline",
    meta: {
      requiresAuth: true,
      renderAt: "main",
      allows: ["role_superadmin", "role_admin", "role_staff"]
    },
    components: {
      default: () => import("../views/clinic/Guideline.vue")
    }
  },
  {
    path: "/liff/init/liff/selectUserPet/:clinic",
    name: "selectUserPet",
    meta: {
      renderAt: "liff"
    },
    props: { liff: true },
    components: {
      liff: () => import("../views/liff/SelectUserPet.vue")
    }
  },
  {
    path: "/liff/init/liff/selectPetReport/:clinic",
    name: "selectPetReport",
    meta: {
      renderAt: "liff"
    },
    props: { liff: true },
    components: {
      liff: () => import("../views/liff/SelectPetReport.vue")
    }
  },
  {
    path: "/liff/init/liff/qrCodeAction/:clinic",
    name: "qrcodeAction",
    meta: {
      renderAt: "liff"
    },
    props: { liff: true },
    components: {
      liff: () => import("../views/liff/QrCodeAction.vue")
    }
  },
  {
    path: "/liff/init",
    name: "liffInit",
    meta: {
      renderAt: "liff"
    },
    props: { liff: true },
    components: {
      liff: () => import("../views/liff/init.vue")
    }
  },
  {
    path: "/liff/test",
    name: "liffTest",
    meta: {
      renderAt: "liff"
    },
    props: { liff: true },
    components: {
      liff: () => import("../views/liff/LiffTest.vue")
    }
  },
  {
    path: "*",
    meta: {
      renderAt: "alone"
    },
    components: {
      alone: () => import("../views/404.vue")
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Vue.prototype.$my.isLogin()) {
      next({
        path: "/login"
      });
    } else {
      if (to.meta.allows.indexOf(Vue.prototype.$my.getPermission()) > -1) {
        next();
      } else {
        next({
          name: "home"
        });
      }
    }
  } else if (to.name === "login" && Vue.prototype.$my.isLogin()) {
    if (Vue.prototype.$my.getPermission() === "role_admin") {
      next({
        name: ADMIN_INIT_PAGE
      });
    } else if (Vue.prototype.$my.getPermission() === "role_staff") {
      next({
        name: EMPLOYEE_INIT_PAGE
      });
    } else {
      next({
        name: SUPER_ADMIN_INIT_PAGE
      });
    }
  } else {
    next();
  }
});

export default router;
